import React from "react";
import { useTenantScope } from "../scope/TenantScopeContext";
import {
  exportVisibleRowsCsv,
  printCurrentReport,
  reportFileStem,
} from "../utils/reporting";
import { exportVisiblePageCsv } from "../utils/domReportExport";
import "../styles/tenantScope.css";

function ReportActions({
  moduleName,
  rows = [],
  columns = [],
  onRefresh,
  disableCsv = false,
}) {
  const scope = useTenantScope();

  const companyName =
    scope.selectedCompany?.company_name ||
    scope.selectedCompany?.name ||
    scope.companyId ||
    "";

  const deviceName =
    scope.selectedDevice?.hostname ||
    scope.selectedDevice?.device_name ||
    scope.deviceUuid ||
    "";

  const fileStem = reportFileStem({
    moduleName,
    companyName,
    deviceName,
  });

  const handlePrint = () => {
    printCurrentReport({
      title: `${moduleName} - Wireless Press`,
    });
  };

  const handleCsv = () => {
    if (Array.isArray(columns) && columns.length > 0) {
      exportVisibleRowsCsv({
        rows,
        columns,
        filename: `${fileStem}.csv`,
      });
      return;
    }

    exportVisiblePageCsv({
      filename: `${fileStem}.csv`,
    });
  };

  return (
    <div className="wp-report-actions no-print" aria-label="Report actions">
      {onRefresh && (
        <button type="button" onClick={onRefresh}>
          Refresh Data
        </button>
      )}
      <button type="button" onClick={handlePrint}>
        Print
      </button>
      <button
        type="button"
        onClick={handlePrint}
        title="Choose Save as PDF in the browser print dialog."
      >
        Save as PDF
      </button>
      <button type="button" onClick={handleCsv} disabled={disableCsv}>
        Export CSV
      </button>
    </div>
  );
}

export default ReportActions;
